import { init as i } from "@fullstory/browser";
async function n({
  orgId: e = process.env.VITE_FULLSTORY_ORG_ID,
  ...o
} = {}) {
  if (!e)
    throw new Error("FullStory misconfigured");
  i({
    orgId: e,
    devMode: process.env.VITE_APP_ENV === "development",
    ...o
  });
}
export {
  n as initializeFullStory
};
